module.exports = __webpack_public_path__ + "img/banner3-3.3a65782f.jpg";